const FEED_LINK_SELECTOR = 'a[href^="/feed/"]';

function feedFromContext() {
  const { pathname } = window.location;
  if (pathname === '/home') return 'home';

  const stockMatch = pathname.match(/^\/stocks\/([^/]+)/i);
  return stockMatch ? stockMatch[1].toLowerCase() : null;
}

function patchFeedLinks(root = document) {
  const from = feedFromContext();
  if (!from) return;

  root.querySelectorAll(FEED_LINK_SELECTOR).forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.includes('from=')) return;

    const separator = href.includes('?') ? '&' : '?';
    link.setAttribute(
      'href',
      `${href}${separator}from=${encodeURIComponent(from)}`
    );
  });
}

function observeFeedLinks() {
  patchFeedLinks();

  if (!document.body) return;

  const observer = new MutationObserver(() => {
    patchFeedLinks();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeFeedLinks);
} else {
  observeFeedLinks();
}
